import { DealershipHolidaysRoutingModule } from './dealership-holidays-routing.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DealershipHolidaysComponent } from './dealership-holidays.component';
import { HolidaysListComponent } from './holidays-list/holidays-list.component';
import { HolidaysCardComponent } from './holidays-card/holidays-card.component';
import { DealershipHolidaysService } from './dealership-holidays.service';
import { SharedModule } from '../shared/shared.module';
import { HolidayComponent } from './holiday/holiday.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [DealershipHolidaysComponent, HolidaysListComponent, HolidaysCardComponent, HolidayComponent],
    imports: [
        CommonModule,
        SharedModule,
        ReactiveFormsModule,
        DealershipHolidaysRoutingModule
    ],
    providers: [DealershipHolidaysService]
})
export class DealershipHolidaysModule { }
